export const getAbsoluteValue = (string) => {
  const newString = string.replaceAll(",", "");
  return parseInt(newString);
};

export const getFormattedString = (value) => {
  if (value < 10) return `0${value}`;
  else return value.toString();
};
